import { STATUS_CREATED, STATUS_CREATED_CODE, } from '../constants/constant';
import { ADD_CHILDREN_KEY, EMPTY_CHILDREN_KEY, MAIN_ROW_KEY, TRAILER_ROW_KEY, mainFormKey } from "./interface";

interface RowKeyProps {
  mainKey?: string;
  childrenKey?: string;
};
interface ChangeKeyProps {
  mainKey?: string;
  childrenKey?: string;
  name?: string;
  value?: any;
};
export function formatRowKey(rowKey?: string): RowKeyProps {
  const rowKeys: RowKeyProps = {};
  if (!rowKey) return rowKeys;
  const keyArr = rowKey.split('-');
  rowKeys.mainKey = keyArr[0];
  rowKeys.childrenKey = keyArr[1] ?? mainFormKey;
  return rowKeys;
}
/**
 * 转换当前表单的name
 * @param rowKey 当前行key
 * @param name 字段名称
 * @returns 
 */
export function formatFormName(rowKey: any, name: any) {
  const key = formatRowKey(rowKey);
  if (!name) return;
  if (Array.isArray(name)) {
    return name.map(item => {
      return [key.mainKey, key.childrenKey, item];
    });
  }
  return [key.mainKey, key.childrenKey, name];
}
/**
 * 转换当前表单名称字段
 * @param changeInfo 
 * @returns 
 */
export function formatChangeInfo(changeInfo: any): ChangeKeyProps {
  const changeKeys: ChangeKeyProps = {};
  const [mainKey, mainValue] = getFileNameInfo(changeInfo);
  changeKeys.mainKey = mainKey;
  if (mainValue) {
    const [childrenKey, childrenValue] = getFileNameInfo(mainValue);
    changeKeys.childrenKey = childrenKey;
    if (childrenValue) {
      const [itemKey, itemValue] = getFileNameInfo(childrenValue);
      changeKeys.name = itemKey;
      changeKeys.value = itemValue;
    }
  }
  return changeKeys;
}
export function getFileNameInfo(fileNameInfo: any): any[] {
  if (!fileNameInfo) return [];
  return [Object.keys(fileNameInfo)[0], Object.values(fileNameInfo)[0]];
}
export function getEffectiveChildren(childrenData: any) {
  let effectiveChildren: any[] = [];
  if (Array.isArray(childrenData) && childrenData.length) {
    effectiveChildren = childrenData.filter(v => !(v?.[ADD_CHILDREN_KEY] || v?.[EMPTY_CHILDREN_KEY]));
  }
  return effectiveChildren;
}
/**
 * 过滤已删除数据
 * @param dataSource 
 * @param hiddenAddSubRow 
 * @returns 
 */
export function filterDeleteData(
  dataSource?: any[],
  hiddenAddSubRow?: (mainData: any) => boolean,
): any[] {
  const effectiveDataSource: any[] = [];
  if (Array.isArray(dataSource) && dataSource.length) {
    dataSource.forEach(item => {
      if (item[STATUS_CREATED_CODE] !== STATUS_CREATED.DELETE) {
        const children = item.children;
        let effectiveChildren: any[] = []
        const hiddenAdd = hiddenAddSubRow ? hiddenAddSubRow(item): false;
        if (Array.isArray(children)) {
          children.forEach(child => {
            if (child[ADD_CHILDREN_KEY]) {
              !hiddenAdd && effectiveChildren.push(child);
              return;
            }
            if (child[STATUS_CREATED_CODE] !== STATUS_CREATED.DELETE) {
              effectiveChildren.push(child);
            }
          });
        }
        effectiveDataSource.push({
          ...item,
          children: effectiveChildren,
        });
      }
    });
  }
  return effectiveDataSource;
}

/**
 * 移除dataSource数据中的内部属性
 * @param dataSource 表格数据
 * @param filterDeleteData 是否过滤空数据
 * @param filterKey 是否过滤内部添加的属性
 * @returns 
 */
export function formatDataSource(dataSource?: any[], filterDeleteData?: boolean, filterKey?: boolean) {
  const newDataSource: any[] = [];
  dataSource?.forEach?.(group => {
    if (filterDeleteData && group[STATUS_CREATED_CODE] === STATUS_CREATED.DELETE) return;
    const { children, ...newGroup } = group;
    if (filterKey) {
      Reflect.deleteProperty(newGroup, 'key');
      Reflect.deleteProperty(newGroup, MAIN_ROW_KEY);
    }
    if (Array.isArray(children) && children.length) {
      const newChildren: any[] = [];
      children.forEach(item => {
        const newItem = {...item};
        if (item[ADD_CHILDREN_KEY] || item[EMPTY_CHILDREN_KEY] || item[TRAILER_ROW_KEY]) return;
        if (filterDeleteData && item[STATUS_CREATED_CODE] === STATUS_CREATED.DELETE) return;
        if (filterKey) {
          Reflect.deleteProperty(newItem, 'key');
        }
        newChildren.push(newItem);
      });
      newGroup.children = newChildren;
    }
    newDataSource.push(newGroup);
  });
  return newDataSource;
}
/**
 * 获取最新的行数据
 * @param mainKey 主表key
 * @param childrenKey 子表key
 * @param formData 当前行表单最新数据集
 * @param dataSource 表格数据
 * @returns 
 */
export function getRowDataSource(mainKey: string, childrenKey: string, formData: any, dataSource?: any[]) {
  const findGroup = dataSource?.find(item => item.key === mainKey);
  if (!findGroup) return;
  if (childrenKey === mainFormKey) {
    return {
      ...findGroup,
      ...formData,
    };
  }
  const findChildren = findGroup.children?.find?.((item: any) => item.key === childrenKey);
  return {
    ...findChildren,
    ...formData,
  };
}
